/**************************************************
 * Nombre:       Formulario_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {
    AccountBalanceOutlined,
    AccountCircleOutlined,
    AssuredWorkloadOutlined,
    AttachMoney,
    BadgeOutlined,
    FlagCircleOutlined,
    FlagOutlined,
    MailOutline,
    Numbers,
    PhoneAndroidOutlined,
    Search,
    WalletOutlined,
    CalendarMonth
} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import 'react-medium-image-zoom/dist/styles.css'
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {useEffect, useState} from "react";
import IngresoSelectPropId from "../../Modulo_formularios/Componentes/IngresoSelectPropId";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOMOVIMIENTOS, TIPOSMOVIMIENTO, TIPOSTRANSACCION} from "../../Constantes";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";

const Formulario_Movimiento = ({...props}) => {
    const [bolsillos, setBolsillos] = useState([]);

    const buscar = async () => {
        let corr = props.props.getValues('correo')


        let wheres = [where('correo', '==', corr)]
        let dox = await obtenerColWheres({col: 'cuentas', wheres: wheres})
        console.log(dox)
        if (dox.res && dox.data[0]) {
            let cuenta = dox.data[0]
            props.props.setValue('nombres', cuenta.nombres);
            props.props.setValue('apellidos', cuenta.apellidos);
            props.props.setValue('cc', cuenta.cc);
            props.props.setValue('celular', cuenta.celular);
            props.props.setValue('idUsuario', cuenta.id);
        }
    }

    useEffect(() => {

        let idUsuario = props.props.getValues('idUsuario');
        if (idUsuario) {
            obtenerColWheres({col: 'bolsillos', wheres: [where('idUsuario', '==', idUsuario)]}).then((dox) => {
                if (dox.res) {
                    setBolsillos(dox.data);
                }
            })
        }

    }, [props.props.watch('idUsuario')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTextoBoton Icono={Search} dato={'correo'} nombre={'Correo'} {...props} click={buscar}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={2}  nombre={'Id'} dato={'idUsuario'} {...props}
                                  requerido={'El Nombres es requerido'} editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}
                                  requerido={'El Nombres es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}
                                  requerido={'El Apellidos es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'} dato={'cc'} {...props}
                                  requerido={'El Numero de identificacion es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Num Celular'} dato={'celular'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Bolsillo</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelectPropId Icono={WalletOutlined} nombre={'Bolsillo'} dato={'nombreBolsillo'}
                                         {...props} opciones={bolsillos} datoId={'idBolsillo'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos Transaccion</Typography>
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoFecha nombre={'Fecha'} dato={'fecha'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Numbers} nombre={'Consecutivo'} dato={'consecutivo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagCircleOutlined} nombre={'Tipo'} dato={'tipo'} {...props}
                                   opciones={TIPOSMOVIMIENTO.map((it) => it.nombre)} requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOMOVIMIENTOS.map((it) => it.nombre)} requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={AccountBalanceOutlined} nombre={'Tipo Transaccion'}
                                   dato={'tipoTransaccion'} {...props}
                                   opciones={TIPOSTRANSACCION.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={AssuredWorkloadOutlined} nombre={'Num Transaccion'}
                                  dato={'numTransaccion'} {...props}

                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={CalendarMonth} nombre={'Mes (Si aplica)'}
                                  dato={'mes'} {...props}

                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoDinero Icono={AttachMoney} nombre={'Valor'} dato={'valor'} {...props}

                    />
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto lineas={5} nombre={'Notas Internas'} dato={'notas'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Movimiento